import React from 'react';
import '../CSS/notFound.css';
import img from '../Images/not_found.jpg';

const NotFound = () => {
  return (
    <div className="error-container">
      <img src={img} alt="404 Error" className="error-image" />
      <h1 className="error-heading">Oops!</h1>
      <h2 className="error-subheading">
        Sorry, the page you are trying to access does not exist. Please check the URL and try again.
      </h2>
    </div>
  );
};

export default NotFound;
